import React, { useRef } from 'react';

import bridge from '@vkontakte/vk-bridge';
import { useSelector } from 'react-redux';

import { PredictionContent } from './PredictionContent';
import { PredictionContentContainerProps } from './types';
import eventsApi from '../../../../../../../api/EventsApi';
import { CONTENT_ITEMS } from '../../../../../../../constants/Content';
import { EVENT_NAME, EVENT_TYPE } from '../../../../../../../constants/Event';
import { PANEL } from '../../../../../../../constants/Panel';
import { POPOUT } from '../../../../../../../constants/Popout';
import { usePopout, useSetPopoutAlert } from '../../../../../../../hooks/usePopout';
import { useRouter } from '../../../../../../../hooks/useRouter';
import { selectLocation } from '../../../../../../../store/routerSlice/routerSelectors';
import { selectUserGrantedTokenScope } from '../../../../../../../store/userSlice/userSelectors';
import { useOnGetTemperamentClick } from '../../../hooks';
import { MAIN_HORIZONTAL_SCROLL_DURATION } from '../../constants';

export const PredictionContentContainer: React.FC<PredictionContentContainerProps> = () => {
  const router = useRouter();
  const { setPopout, resetPopout } = usePopout();

  const setPopoutAlert = useSetPopoutAlert();

  const grantedTokenScope = useSelector(selectUserGrantedTokenScope);
  const {
    onGetMyTemperamentClick,
    onGetFriendTemperamentClick
  } = useOnGetTemperamentClick();


  const predictionContentRef = useRef<HTMLDivElement>(null);
  const location = useSelector(selectLocation);

  const onGetToken = async () => {
    const accessToken = await onGetFriendTemperamentClick();
    if (accessToken) {
      router.forward({
        location: { content: CONTENT_ITEMS.USER_ENTERING },
        handler: 'forward'
      });
    } else {
      setPopoutAlert(
        'Произошла ошибка при получении доступа',
        'При работе сервиса произошла ошибка, попробуйте нажать на кнопку "Узнать профессиональнй тип" еще раз',
      );
    }
  };

  const handleOnGetTemperament = async () => {
    setPopout(POPOUT.SMART_SPINNER);
    await eventsApi.sendStatistics({
      type: EVENT_TYPE.GO_THROUGH,
      name: EVENT_NAME.USER_CLICKED_CHECK_ME_BUTTON,
      data: { message: 'Clicked on mobile' },
      route: location,
    });
    resetPopout();

    onGetMyTemperamentClick();
    router.forward({ panel: PANEL.RESULT });
  };

  const handleOnGetFriendTemperament = async () => {
    setPopout(POPOUT.SMART_SPINNER);
    await eventsApi.sendStatistics({
      type: EVENT_TYPE.GO_THROUGH,
      name: EVENT_NAME.USER_CLICKED_CHECK_SOMEONE_BUTTON,
      data: { message: 'Clicked on mobile' },
      route: location,
    });
    resetPopout();

    // TODO: Временное
    // setPopoutAlert(
    //   'Функциональность недоступна',
    //   'На текущий момент приложение находится в полу-тестовом режиме и проходит модерацию со стороны ВК. Данная функциональность содержит оплату голосами, а она недоступна без прохождения модерации.',
    //   () => {},
    //   'Хорошо'
    // );

    setPopout(POPOUT.SMART_SPINNER);
    const { platform } = await bridge.send('VKWebAppGetClientVersion');
    resetPopout();

    if (platform === 'ios') {
      setPopoutAlert(
        'Оплата голосами недоступна на вашем устройстве',
        (
          <span>
            Воспользуйтесь веб-приложением, мобильным устройством на Android, либо зайдите на мобильную веб-версию через браузер по ссылке <a href='https://m.vk.com/app51929418'>https://m.vk.com/app51929418</a>.
          </span>
        ),
      );
    } else {
      predictionContentRef.current?.scrollIntoView();

      if (grantedTokenScope && grantedTokenScope.includes('friends')) {
        onGetToken();
      } else {
        setPopoutAlert(
          'Необходимы дополнительные разрешения',
          'Для дальнейшей работы приложения нужен доступ к Вашим друзьям. Без этого доступа узнать профессиональный тип не получится',
          onGetToken,
          'Хорошо'
        );
      }
    }
  };


  return (
    <PredictionContent 
      handleOnGetFriendTemperament={handleOnGetFriendTemperament}
      handleOnGetTemperament={handleOnGetTemperament}
      delayAnimation={MAIN_HORIZONTAL_SCROLL_DURATION}
    />
  );
};

export default PredictionContentContainer;

